import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/Modal';
import AccountSelector from '../containers/AccountSelector';

const QuickBooksSettings = (props) => {
  const {
    quickBooksOn,
    quickBooksOff,
    quickBooksIsOn,
    connect,
    disconnect,
    onSubmit,
    onSelectAccount,
    isConnected,
    accountMap,
    bankAccountTypes,
    depositAccounts,
    valid,
    submitting,
    connectionButtonText,
  } = props;

  return (
    <div>
      <button
        type="button"
        className="c-btn c-btn--medium u-ml"
        onClick={isConnected ? quickBooksOn : connect}
      >
        {!isConnected ? connectionButtonText : 'Quickbooks settings'}
      </button>
      <Modal
        display-if={quickBooksIsOn}
        close={quickBooksOff}
        title="Quickbooks Settings"
        showCloseButton
      >
        <form onSubmit={onSubmit} className="u-max-width-750">
          <div className="u-pv u-ph++">
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">
                    Bank account type where money is being deposited:
                  </span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={bankAccountTypes}
                    value={accountMap.bankAccountType}
                    onChange={(account) => {
                      onSelectAccount('bankAccountType', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="c-separator u-mt" />
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit service sales to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.servicesAccount}
                    onChange={(account) => {
                      onSelectAccount('servicesAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit service sale taxes to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.servicesTaxAccount}
                    onChange={(account) => {
                      onSelectAccount('servicesTaxAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit product sales to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.productsAccount}
                    onChange={(account) => {
                      onSelectAccount('productsAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit product sale taxes to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.productsTaxAccount}
                    onChange={(account) => {
                      onSelectAccount('productsTaxAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit fees to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.feesAccount}
                    onChange={(account) => {
                      onSelectAccount('feesAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit financing repayment to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.financingPaydownAccount}
                    onChange={(account) => {
                      onSelectAccount('financingPaydownAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit tips to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.tipsAccount}
                    onChange={(account) => {
                      onSelectAccount('tipsAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit discounts to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.discountsAccount}
                    onChange={(account) => {
                      onSelectAccount('discountsAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit promos given to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.promosAccount}
                    onChange={(account) => {
                      onSelectAccount('promosAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit refunds to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.refundsAccount}
                    onChange={(account) => {
                      onSelectAccount('refundsAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit gift card sales to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.giftCardsAccount}
                    onChange={(account) => {
                      onSelectAccount('giftCardsAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="o-tableize u-mt">
              <div className="o-tableize__row">
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <span className="c-label c-label--strong u-mr-">Deposit cash incomes to:</span>
                </div>
                <div className="o-tableize__cell u-1/2-medium-and-up">
                  <AccountSelector
                    accounts={depositAccounts}
                    value={accountMap.cashAccount}
                    onChange={(account) => {
                      onSelectAccount('cashAccount', account);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="c-separator u-mb u-mt" />
            <div className="o-flexbox o-flexbox--justify-between u-mt+">
              <button
                onClick={disconnect}
                disabled={submitting}
                type="button"
                className="c-btn c-btn--red c-btn--medium u-mr"
              >
                Disconnect account
              </button>
              <div>
                <button
                  onClick={quickBooksOff}
                  disabled={submitting}
                  type="button"
                  className="c-btn c-btn--grey c-btn--medium u-mr"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="c-btn c-btn--medium"
                  disabled={submitting || !valid}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

QuickBooksSettings.propTypes = {
  quickBooksOn: PropTypes.func.isRequired,
  quickBooksOff: PropTypes.func.isRequired,
  quickBooksIsOn: PropTypes.bool.isRequired,
  connect: PropTypes.func.isRequired,
  disconnect: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSelectAccount: PropTypes.func.isRequired,
  isConnected: PropTypes.bool.isRequired,
  bankAccountTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  depositAccounts: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  accountMap: PropTypes.shape({
    bankAccountType: PropTypes.string,
    discountsAccount: PropTypes.string,
    promosAccount: PropTypes.string,
    refundsAccount: PropTypes.string,
    servicesAccount: PropTypes.string,
    servicesTaxAccount: PropTypes.string,
    productsAccount: PropTypes.string,
    productsTaxAccount: PropTypes.string,
    giftCardsAccount: PropTypes.string,
    feesAccount: PropTypes.string,
    financingPaydownAccount: PropTypes.string,
    tipsAccount: PropTypes.string,
    cashAccount: PropTypes.string,
  }).isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  connectionButtonText: PropTypes.string,
};
QuickBooksSettings.defaultProps = {
  bankAccountTypes: [],
  depositAccounts: [],
  connectionButtonText: 'Connect to QuickBooks',
};

export default QuickBooksSettings;
